import {
  GasRoutePreview,
  SectorAllowedRoutes,
  SectorInformation,
} from '@gasbi/shared/web/Gds';
import { RouteObject } from 'react-router-dom';

import { Pages } from '@/pages';

export const gdsSectorDetailsRoutes: RouteObject[] = [
  {
    element: <SectorInformation />,
    index: true,
  },
  {
    path: Pages.ALLOWED_ROUTES,
    element: <SectorAllowedRoutes />,
    children: [{ path: ':gasRouteId', element: <GasRoutePreview /> }],
  },
];
